import { Action } from '@ngrx/store';

export class ResponseError implements Action {
  constructor(readonly type: any, readonly response: { message: any; content: any }) {}
}
